import React from "react"
import ByAStudent from "../components/by-a-student"
import Contact from "../components/contact"
import Features from "../components/features"
import Hero from "../components/hero"
import Layout from "../components/layout"
import Showcase from "../components/showcase"
import config from "../lib/config"
import { Helmet } from "react-helmet"

export default function Example() {
  return (
    <Layout homepage={true}>
      <Helmet>
        <title>
          {config.siteTitle} &mdash; {config.siteShortDescription}
        </title>
      </Helmet>
      <Hero />
      <Showcase />
      <Features />
      <ByAStudent />
      <Contact />
    </Layout>
  )
}
